import { Component } from '@angular/core';

import { MessengerSmsComponent } from '../messages/messenger/messenger.sms.component';

@Component({
  selector   : 'dealership-send-sms',
  template: require('./dealership.send-sms.component.html')
})
export class DealershipSendSmsComponent extends MessengerSmsComponent {}
